import api from '@/core/services/axios.js';

const BASE = '/support';

export const supportApi = {
    getTickets(params = {}) {
        return api.get(`${BASE}/tickets`, { params });
    },

    createTicket(title) {
        return api.post(`${BASE}/tickets`, { title });
    },

    getMessages(ticketId, params = {}) {
        return api.get(`${BASE}/tickets/${ticketId}/messages`, { params });
    },

    sendMessage(ticketId, text) {
        return api.post(`${BASE}/tickets/${ticketId}/messages`, { text });
    },

    markAsRead(ticketId) {
        return api.post(`${BASE}/tickets/${ticketId}/read`);
    },

    getUnreadCount() {
        return api.get(`${BASE}/unread-count`);
    },

    sendForm(params = {}) {
        return api.post(`${BASE}/send-form-message`, params);
    }
};
